import { useQuery } from 'react-query'
import { PaymentMethod } from '../../Interfaces/paymentMethod'
import { api } from '../api'

export type PaymentMethodsQuery = {
  page?: number
  limit?: number
  search?: string
  is_active?: boolean | string
}

type PaymentMethodsResponse = {
  paymentMethods: PaymentMethod[]
  totalCount: number
}

export async function getPaymentMethods(params?: PaymentMethodsQuery): Promise<PaymentMethodsResponse> {
  const { data } = await api.get('payment-methods', {
    params,
  })

  const payload = data?.data

  if (payload?.data) {
    return {
      paymentMethods: payload.data,
      totalCount: payload.meta?.total ?? payload.data.length,
    }
  }

  return {
    paymentMethods: payload ?? [],
    totalCount: Array.isArray(payload) ? payload.length : 0,
  }
}

export function usePaymentMethods(params?: PaymentMethodsQuery) {
  return useQuery(['payment-methods', params], () => getPaymentMethods(params), {
    staleTime: 5000,
  })
}
